import { component } from 'picoapp'
import $ from 'quantdom'
import { centsToDollars } from '../lib/utils'

export default component((node) => {
  function initFrequencySelector(data) {
    const newFrequncySelector = document.getElementById('IG-frequency-variant')
    if (!newFrequncySelector) return

    const allRadios = [
      ...newFrequncySelector.querySelectorAll('input[name="delivery"]'),
      ...newFrequncySelector.querySelectorAll('input[name="subscription-type"]'),
    ]

    allRadios.forEach((radio) => {
      $(radio).on('change', (e) => {
        const target = e.target
        const { value, name } = target
        if (target && target.hasAttribute('data-selling-plan-id')) {
          updateSellingPlan(target, true)
        } else {
          const selectedFrequency = newFrequncySelector.querySelector('input[name="subscription-type"]:checked')
          updateSellingPlan(selectedFrequency, true)
        }

        if (value === 'one-time') {
          window.MicroBus.emit('igEvents:push', {
            event: 'One Time Frequency - Clicked',
          })
        }

        window.dispatchEvent(
          new CustomEvent('frequency-selector:change', {
            detail: {
              name,
              value,
            },
          })
        )
      })
      if (data && radio?.name === 'subscription-type') {
        radio.checked = data?.selling_plan == radio.dataset?.sellingPlanId
        if (radio.checked) radio.dispatchEvent(new Event('change'))
      }
    })
  }

  function updateSellingPlan(target, isNewSelector = false) {
    const variantId = $(target).attr('data-variant-id')
    const productId = $(target).attr('data-product-id')
    const selling_plan = $(target).attr('data-selling-plan-id')
    const price = $(target).attr('data-selling-plan-price')
    const compareAtPrice = $(target).attr('data-selling-plan-compare-at-price')
    const omegaVariantId = $(target).attr(`data-variant-id-${getSelectedOmega()}`)
    const scentVariantId = getSelectedScent(target)
    const sellingPlanMonths = $(target).attr('data-selling-plan-months')
    const variantHasOverrideText = $(`.js-promo-call-out[data-${variantId}-override-text]`).el()
    const isOTP = sellingPlanMonths == 0
    $('.js-delivery-dropdown').attr('data-selected-selling-plan-id', selling_plan)
    $('.js-delivery-dropdown').attr('data-current-selling-plan-months', sellingPlanMonths)
    $('.js-delivery-dropdown').attr('data-selected-product-id', productId)
    if (scentVariantId) {
      $('.js-delivery-dropdown').attr('data-selected-variant-id', scentVariantId)
    }
    const practitionerActive = $(`.js-promo-call-out`).attr('data-practitioner-active')
    const affiliateName = window?.CartJS?.getAttribute('wholesaler_name')
    const isPlan = $(`.js-promo-call-out`).attr('data-is-plan')

    let data = {
      variantId: variantId,
      productId: productId,
      selling_plan: selling_plan,
      price: price,
      selling_plan_months: sellingPlanMonths,
    }

    updateDropdownItems(selling_plan)

    if (omegaVariantId) {
      data.variantId = omegaVariantId
    }

    if (scentVariantId) {
      data.variantId = scentVariantId
    }

    function calcStackedDiscount(a, b) {
      return Math.round(a + b - (a * b) / 100)
    }

    if (!isNewSelector && sellingPlanMonths) {
      const deliveryType = isOTP ? 'One Time' : `${sellingPlanMonths} Month`
      const eventName = 'Delivery Dropdown Click'

      if (window?.gtag) {
        window.gtag('event', eventName, {
          event_detail: deliveryType,
        })
      }
      window.dispatchEvent(
        new CustomEvent('frequency-selector:change', {
          detail: {
            eventName,
            deliveryType,
          },
        })
      )
    }

    if (!isOTP) {
      $('.js-monthly-price').text('$' + centsToDollars(price))
      $('.js-monthly-compare-at-price').text('$' + centsToDollars(compareAtPrice))
      $('.js-per-day-cost').text('($' + centsToDollars(price / (sellingPlanMonths * 30)) + '/ day)')
      $('.js-current-delivery').attr('data-selected-selling-plan-id', selling_plan)
      $('.js-current-delivery').attr('data-current-selling-plan-months', sellingPlanMonths)
      $('.js-current-delivery').attr('data-selected-product-id', productId)
    }

    if (variantHasOverrideText) {
      let overrideText = $(`.js-promo-call-out`).attr(`data-${variantId}-override-text`)
      const overrideColor = $(`.js-promo-call-out`).attr(`data-${variantId}-override-background-color`)
      const overrideIconEnabled = $(`.js-promo-call-out`).attr(`data-${variantId}-enable-icon`)
      if (overrideText) {
        if (window?.evergreen_sale?.enabled && window?.evergreen_sale?.percent && window?.evergreen_sale?.code) {
          overrideText = overrideText.replace('[discount_percent]', window?.evergreen_sale?.percent)
          overrideText = overrideText.replace('[discount_code]', window?.evergreen_sale?.code)
        }
        $(`.js-promo-call-out-text`).text(overrideText)
        $('.js-promo-call-out').attr('data-override-active', 'true')
        if (overrideColor) {
          $('.js-promo-bg').css('background-color', overrideColor)
          $('.js-promo-bg-icon>path').attr('fill', overrideColor)
        }
        if (overrideIconEnabled == 'true') {
          $('.js-promo-call-out-icon').attr('aria-hidden', false)
        } else {
          $('.js-promo-call-out-icon').attr('aria-hidden', true)
        }
      }
    } else if (practitionerActive === 'true' && affiliateName) {
      let text = $('.js-promo-call-out').attr('data-practitioner-text')
      if (text) {
        text = text.replace('[name]', affiliateName)
        if (window?.evergreen_sale?.enabled && window?.evergreen_sale?.percent && window?.evergreen_sale?.code) {
          text = text.replace('[discount_code]', window.evergreen_sale.code)
          const stackedDiscount = $('.js-promo-call-out').attr('data-plan-discount')
          if (isPlan == 'true' && stackedDiscount) {
            text = text.replace('[discount_percent]', stackedDiscount + '%')
          } else {
            let sellingPlanMonths = null
            let additionalDiscount = 0

            if ($('.js-delivery-dropdown').el()) {
              sellingPlanMonths = Number($('.js-delivery-dropdown').attr('data-current-selling-plan-months'))
            }
            if (sellingPlanMonths == 0) {
              text = text.replace('[discount_percent]', window.evergreen_sale.percent + '%')
            } else {
              if (sellingPlanMonths == 1) additionalDiscount = 10
              if (sellingPlanMonths == 3) additionalDiscount = 15
              if (sellingPlanMonths == 6) additionalDiscount = 25
              if (sellingPlanMonths == 9) additionalDiscount = 30
              text = text.replace(
                '[discount_percent]',
                calcStackedDiscount(window.evergreen_sale.percent, additionalDiscount) + '%'
              )
            }
          }
        }
        $('.js-promo-call-out-text').text(text)
        $('.js-promo-call-out').attr('data-override-active', 'false')
        const defaultColor = $('.js-promo-call-out').attr('data-default-color')
        $('.js-promo-bg').css('background-color', defaultColor)
        $('.js-promo-bg-icon>path').attr('fill', defaultColor)
        $('.js-promo-call-out-icon').attr('aria-hidden', false)
      }
    } else if (isPlan == 'true') {
      let text = $('.js-promo-call-out').attr('data-sub-text')
      const stackedDiscount = $('.js-promo-call-out').attr('data-plan-discount')
      if (text) {
        if (
          window?.evergreen_sale?.enabled &&
          window?.evergreen_sale?.percent &&
          window?.evergreen_sale?.code &&
          stackedDiscount
        ) {
          text = text.replace('[discount_percent]', stackedDiscount + '%')
          text = text.replace('[discount_code]', window.evergreen_sale.code)
        }
        $('.js-promo-call-out-text').text(text)
        $('.js-promo-call-out').attr('data-override-active', 'false')
        const defaultColor = $('.js-promo-call-out').attr('data-default-color')
        $('.js-promo-bg').css('background-color', defaultColor)
        $('.js-promo-bg-icon>path').attr('fill', defaultColor)
        $('.js-promo-call-out-icon').attr('aria-hidden', false)
      }
    } else if (
      window?.evergreen_sale?.enabled &&
      window?.evergreen_sale?.percent &&
      window?.evergreen_sale?.code &&
      $('.js-promo-call-out').el()
    ) {
      let sellingPlanMonths = null
      if ($('.js-delivery-dropdown').el()) {
        sellingPlanMonths = Number($('.js-delivery-dropdown').attr('data-current-selling-plan-months'))
      }
      let text = null
      let additionalDiscount = 0
      if (sellingPlanMonths == 0) {
        text = $('.js-promo-call-out').attr('data-otp-text')
        if (text) text = text.replace('[discount_percent]', window.evergreen_sale.percent + '%')
      } else {
        text = $('.js-promo-call-out').attr('data-sub-text')
        if (sellingPlanMonths == 1) additionalDiscount = 10
        if (sellingPlanMonths == 3) additionalDiscount = 15
        if (sellingPlanMonths == 6) additionalDiscount = 25
        if (sellingPlanMonths == 9) additionalDiscount = 30
      }
      if (text) {
        text = text.replace(
          '[discount_percent]',
          calcStackedDiscount(window.evergreen_sale.percent, additionalDiscount) + '%'
        )
        $('.js-promo-call-out-text').text(text.replace('[discount_code]', window.evergreen_sale.code))
        $('.js-promo-call-out').attr('data-override-active', 'false')
        const defaultColor = $('.js-promo-call-out').attr('data-default-color')
        $('.js-promo-bg').css('background-color', defaultColor)
        $('.js-promo-bg-icon>path').attr('fill', defaultColor)
        $('.js-promo-call-out-icon').attr('aria-hidden', false)
      }
    } else if ($('.js-promo-call-out').el()) {
      let sellingPlanMonths = null
      if ($('.js-delivery-dropdown').el()) {
        sellingPlanMonths = Number($('.js-delivery-dropdown').attr('data-current-selling-plan-months'))
      }
      let text = null
      if (sellingPlanMonths == 0) {
        text = $('.js-promo-call-out').attr('data-otp-text')
      } else {
        text = $('.js-promo-call-out').attr('data-sub-text')
      }
      if (text) {
        $('.js-promo-call-out-text').text(text)
        $('.js-promo-call-out').attr('data-override-active', 'false')
        const defaultColor = $('.js-promo-call-out').attr('data-default-color')
        $('.js-promo-bg').css('background-color', defaultColor)
        $('.js-promo-bg-icon>path').attr('fill', defaultColor)
        $('.js-promo-call-out-icon').attr('aria-hidden', false)
      }
    }

    // Replace selected
    const targetContent = $(target).find('[data-plan-contents]')
    if (targetContent.el()) {
      $(node).find('[data-selected-item]').html(targetContent.el().innerHTML)
    }
    window.MicroBus.emit('variant:selling-plan-change', data)
  }

  function updateDropdownItems(currentSellingPlan) {
    const items = $('dropdown-button[data-dropdown-button-type="delivery"]').find(`.js-delivery-list-item`).els
    for (let i = 0; i < items.length; i++) {
      if ($(items[i]).attr('data-selling-plan-id') == currentSellingPlan) {
        $(items[i]).addClass('tw-hidden')
        $(items[i]).addClass('selected')
        $(node).find('[data-selected-item]').html($(items[i]).find('[data-plan-contents]').el().innerHTML)
      } else {
        $(items[i]).removeClass('tw-hidden')
        $(items[i]).removeClass('selected')
      }
    }
  }

  function getCurrentData() {
    const urlParams = new URLSearchParams(window.location.search)
    let selectedVariantId = $(node).find('[data-selected-variant-id]').attr('data-selected-variant-id') ?? null
    let productId = $(node).find('[data-selected-product-id]').attr('data-selected-product-id') ?? null
    let selectedSellingPlan = $(node).find('[data-selected-selling-plan-id]').attr('data-selected-selling-plan-id') ?? null
    let selectedPrice = $(node).find('[data-selected-selling-plan-price]').attr('data-selected-selling-plan-price') ?? null
    let selectedSellingPlanMonths =
      $(node).find('[data-current-selling-plan-months]').attr('data-current-selling-plan-months') ?? null

    if (urlParams.get('variant')) {
      selectedVariantId = urlParams.get('variant')
      const selectedVariant = window.allVariants.find((variant) => variant.id == selectedVariantId)
      productId = selectedVariant?.product_id
      selectedSellingPlan = selectedVariant?.selling_plan_allocations[0].selling_plan_id
      selectedSellingPlanMonths = $(node)
        .find(`.js-delivery-list-item[data-selling-plan-id="${selectedSellingPlan}"]`)
        .attr('data-selling-plan-months')
    }

    return {
      variantId: selectedVariantId,
      productId: productId,
      selling_plan: selectedSellingPlan,
      price: selectedPrice,
      selling_plan_months: selectedSellingPlanMonths,
    }
  }

  window.MicroBus.on('window:pdp-js-ready', (e) => {
    console.log('window:pdp-js-ready')

    var urlParams = new URLSearchParams(window.location.search)
    var deliverySchedule = urlParams.get('delivery-schedule')?.toLowerCase()
    let variantId = urlParams.get('variant') ?? null

    if (deliverySchedule) {
      let currentOption
      let selling_plan
      let price
      let productId
      if (deliverySchedule == 'one-time') {
        currentOption = $(node).find('[data-selling-plan-one-time-purchase = "true"]')
      } else if (deliverySchedule == 'monthly') {
        currentOption = $(node).find('[data-selling-plan-one-time-purchase = "false"][data-selling-plan-months="1"]')
      } else if (deliverySchedule == '3-month') {
        currentOption = $(node).find('[data-selling-plan-one-time-purchase = "false"][data-selling-plan-months="3"]')
      } else if (deliverySchedule == '6-month') {
        currentOption = $(node).find('[data-selling-plan-one-time-purchase = "false"][data-selling-plan-months="6"]')
      } else if (deliverySchedule == '9-month') {
        currentOption = $(node).find('[data-selling-plan-one-time-purchase = "false"][data-selling-plan-months="9"]')
      }
      if (variantId == null) {
        variantId = currentOption.attr('data-variant-id') ?? null
      }
      selling_plan = currentOption.attr('data-selling-plan-id') ?? null
      price = currentOption.attr('data-selling-plan-price') ?? null
      productId = $('#product-above-fold').find('[data-product-id]').attr('data-product-id') ?? null
      let sellingPlanMonths = currentOption.attr('data-selling-plan-months') ?? null

      const data = {
        variantId: variantId,
        selling_plan: selling_plan,
        productId: productId,
        price: price,
        selling_plan_months: sellingPlanMonths,
      }

      updateDropdownItems(selling_plan)
      const newHtml = currentOption.find('[data-plan-contents]').el().innerHTML
      $(node).find('[data-selected-item]').html(newHtml)
      window.MicroBus.emit('variant:selling-plan-change', data)
      initFrequencySelector(data)
    } else {
      const currentData = getCurrentData()
      updateDropdownItems(currentData?.selling_plan)
      window.MicroBus.emit('variant:selling-plan-change', currentData)
      initFrequencySelector(currentData)
    }
  })

  window.MicroBus.on(`product:html-replaced`, (e) => {
    console.log('product:html-replaced', e.detail)

    let selectedVariantId = e.detail.three_month_id ?? null
    let selectedSellingPlan = e.detail.selling_plan_id ?? null
    let selectedPrice =
      $('#product-above-fold').find('[data-selected-selling-plan-price]').attr('data-selected-selling-plan-price') ?? null
    let productId = $('#product-above-fold').find('[data-product-id]').attr('data-product-id') ?? null
    let selectedSellingPlanMonths = 3 ?? null

    const data = {
      variantId: selectedVariantId,
      productId: productId,
      selling_plan: selectedSellingPlan,
      price: selectedPrice,
      selling_plan_months: selectedSellingPlanMonths,
    }

    updateDropdownItems(data.selling_plan)

    window.MicroBus.emit('variant:selling-plan-change', data)
  })
  $(node).on('click', (e) => {
    const target = $(e.target).attr('data-selling-plan-id') == undefined ? e.target.closest('li') : e.target
    if (target && target.hasAttribute('data-selling-plan-id')) {
      updateSellingPlan(target)
    }
  })

  const getSelectedOmega = () => {
    const omegaDropdown = $('dropdown-button[data-dropdown-button-type="omega type"] li.selected')
    if (omegaDropdown.els.length > 0) {
      const selectedOmegaHandle = omegaDropdown.attr('data-product-handle')
      return selectedOmegaHandle
    }
  }

  const getSelectedScent = (target) => {
    const currentScentHandle =
      $('input[name="option-scent"]:checked').els.length > 0
        ? $('input[name="option-scent"]:checked')?.attr('data-handle')
        : null
    if (!currentScentHandle) return
    const scentSelected = $(target).attr(`data-variant-id-${currentScentHandle}`) ?? null
    if (scentSelected != null) {
      return scentSelected
    }
  }
})
